import type { Resource } from '../../';
export const country_countries_SI: Resource = {"default":"Slovenia"};
